import { render } from "./ScrollUpDown.vue?vue&type=template&id=7acfde96"
import script from "./ScrollUpDown.vue?vue&type=script&lang=js"
export * from "./ScrollUpDown.vue?vue&type=script&lang=js"

import "./ScrollUpDown.vue?vue&type=style&index=0&id=7acfde96&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__